import { render, staticRenderFns } from "./MenuSystemPermissions.vue?vue&type=template&id=1516d225"
import script from "./MenuSystemPermissions.vue?vue&type=script&lang=js"
export * from "./MenuSystemPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports